import { SET_TOOLTIP_BLOCKER, SET_TOOLTIPS } from 'reducers/actions-types';

let id = 0;
/**
 *
 * @param {string} groupName
 * @param {Document} element
 * @param {object} config
 * @return {Function}
 */
const add = (groupName, element, config) => {
    return function(dispatch, getState) {
        let { tooltips } = getState().tooltip;

        if (!tooltips[groupName]) {
            tooltips[groupName] = [];
        }

        let group = tooltips[groupName];

        const tooltip = {
            id,
            config,
            element,
        };

        let sameTooltips = group.filter((_tooltip) => {
            return (_tooltip.element === element);
        });


        if (sameTooltips.length <= 0) {
            tooltips[groupName].push(tooltip);
            id++;
        } else {
            group = tooltips[groupName].map((_tooltip) => {
                if (_tooltip.element === element) {
                    _tooltip.config.content = config.content;
                    _tooltip.config.mustShow = config.mustShow;
                }

                return Object.assign({}, _tooltip);
            });
            tooltips[groupName] = group;
        }

        dispatch({ type: SET_TOOLTIPS, tooltips: Object.assign({}, tooltips) });
    };
};

/**
 * Remove tooltip
 * @param {string} groupName
 * @param {Element} element
 * @return {Function}
 */
const remove = (groupName, element) => {
    return function(dispatch, getState) {
        let { tooltips } = getState().tooltip;

        if (!tooltips[groupName]) {
            return;
        }

        tooltips[groupName] = tooltips[groupName].map((tooltip) => {
            if (tooltip.element === element) {
                tooltip.config.mustShow = false;
            }

            return Object.assign({}, tooltip);
        });
        //
        // tooltips[groupName] = tooltips[groupName].filter((tooltip) => {
        //     return (tooltip.element !== element);
        // });

        dispatch({ type: SET_TOOLTIPS, tooltips: Object.assign({}, tooltips) });
    };
};


/**
 * Remove complete group
 * @param {string} groupName
 * @return {Function}
 */
const removeGroup = (groupName) => {
    return function(dispatch, getState) {
        const { tooltips } = getState().tooltip;

        if (!tooltips[groupName]) {
            return;
        }

        tooltips[groupName] = [];

        dispatch({ type: SET_TOOLTIPS, tooltips });
    };
};

export default Object.freeze({
    setBlocked({ areBlocked }) {
        return { type: SET_TOOLTIP_BLOCKER, areBlocked };
    },
    add,
    remove,
    removeGroup,
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/tooltip/actions.js